import React from "react";
import "./projectOverview.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";

export function kiloToMegaWatt(value) {
  let change = value;
  if (value > 1000) {
    change = Number((Number(value) / 1000).toFixed(2));
    change = change + " MW";
  } else {
    change = Number(Number(value).toFixed(2));
    change = change + " kW";
  }
  return change;
}

const ProjectOverview = (props) => {
  const { tableContent, roofDetail, index } = props;
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const Check = quantityInfo.allRoof;
  let inverterInfo = [];

  const currency = roofInfo?.value?.financialAnalysis?.currency || "PKR";
  const selectionType = roofDetail?.structureType || "Multiple Structure";
  let structureType = roofDetail?.mountingStructure || "";
  let roofType = roofDetail?.roofType || "";

  let noOfMountingStructure = "--";
  let totalCapacity = 0;
  let pvModule = 0;
  let yeild = 0;

  const list = roofDetail?.multipleStructure || [];

  if (Check && quantityInfo.electricalConfiguration === "All Roof") {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      structureType = "Multipe Structure";
      roofType = "Multiple Roof";
      if (element.structureType === "Single") {
        totalCapacity += Number(element.totalKilowatt);
        pvModule += element.pvModule;
      } else {
        const totalKilowatt = Number(
          element.multipleStructure
            .reduce((total, data) => total + data.totalKilowatt, 0)
            .toFixed(1)
        );
        totalCapacity += Number(totalKilowatt);

        const noOfModule = Object.values(element.multipleStructure).reduce(
          (sum, value) => sum + value.pvModule,
          0
        );
        pvModule += noOfModule;
      }
      yeild += element.actualGeneration.reduce(
        (total, data) => total + data,
        0
      );
    }
  } else {
    if (selectionType === "Single") {
      totalCapacity = Number(roofDetail.totalKilowatt);
      pvModule = roofDetail.pvModule;
      if (roofDetail.roofType === "Flat Roof") {
        noOfMountingStructure = roofDetail.totalStructure;
      }
    } else {
      const totalKilowatt = Number(
        list.reduce((total, data) => total + data.totalKilowatt, 0).toFixed(1)
      );
      totalCapacity += Number(totalKilowatt);

      const noOfModule = Object.values(list).reduce(
        (sum, value) => sum + value.pvModule,
        0
      );
      pvModule += noOfModule;
      noOfMountingStructure = list
        .reduce((total, data) => total + parseFloat(data.totalStructure), 0)
        .toFixed(0);
      structureType = "Multi Structure";
    }
    yeild = roofDetail.actualGeneration.reduce(
      (total, data) => total + data,
      0
    );
  }

  if (quantityInfo.electricalConfiguration === "All Roof") {
    inverterInfo = roofInfo.value.inverterAnalysis;
  } else {
    inverterInfo = roofDetail.inverterAnalysis;
  }

  let energy = 1500 * totalCapacity;
  let co2Avoided = ((energy * 0.475) / 1000).toFixed(2);
  let pvYeild = yeild / totalCapacity;

  let projectInfo = [
    {
      title: "Project Name",
      value: roofInfo.value.siteName,
    },
    {
      title: "Address",
      value: roofInfo.value.siteAddress.value,
    },
    {
      title: "Customer Name",
      value: roofInfo.value.customerName,
    },
  ];

  let customerInfo = [
    {
      title: "Customer Name",
      value: roofInfo.value.customerName,
    },
    {
      title: "Customer Email",
      value: roofInfo.value.customerEmail,
    },

    {
      title: "Customer Phone No",
      value: roofInfo.value.customerPhoneNo,
    },
  ];

  let pvPanel = [
    {
      title: "System Size",
      value: `${kiloToMegaWatt(totalCapacity)}p`,
    },
    {
      title: "Number of PV modules",
      value: pvModule.toLocaleString("en-US"),
    },
    {
      title: "Total Peak Power",
      value: `${kiloToMegaWatt(totalCapacity)}p`,
    },
  ];

  let solarStructure = [
    {
      title: "Number of Mounting structures",
      value: noOfMountingStructure,
    },
    {
      title: "Type of structure",
      value: structureType,
    },
    {
      title: "Type of roof",
      value: roofType,
    },
  ];

  let inverter = [
    {
      title: "Number of inverters",
      value: inverterInfo.noOfInverter,
    },
    {
      title: "Inverter Type",
      value: inverterInfo.inverterType,
    },
    {
      title: "Specific PV yield",
      value: `${Number(pvYeild.toFixed()).toLocaleString("en-US")} kWh/kWp`,
    },
  ];

  let environmentalBenifits = [
    {
      title: "Total CO2 Avoided",
      value: `${Number(((energy * 0.475) / 1000).toFixed(1)).toLocaleString(
        "en-US"
      )} ton/year`,
    },
    {
      title: "Total Trees saved",
      value: `${Number((co2Avoided / 40).toFixed(2)).toLocaleString(
        "en-US"
      )} k/year`,
    },
    {
      title: "Total Coal Avoided",
      value: `${Number(((energy * 0.4) / 1000).toFixed(1)).toLocaleString(
        "en-US"
      )} ton/year`,
    },
  ];

  let ProjectDetail = [
    {
      title: "Estimated Project Cost",
      value: `${Number(roofInfo.value.financialAnalysis.tpc).toLocaleString(
        "en-US"
      )} ${currency}`,
    },
  ];

  function tableRender(title, tableData) {
    let value = "";

    if (title === "Inverter" && inverterInfo.inverterType === "Select") {
      if (quantityInfo.electricalConfiguration === "All Roof") {
        value = "*Required all roof configuration";
      } else {
        value = "*Required single roof configuration";
      }
    }

    return (
      <div className="render-function">
        <p>
          {title} <span className="alert">{value}</span>
        </p>
        <table className="render-table">
          <thead>
            <tr>
              <td>Property</td>
              <td>Value</td>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => {
              return (
                <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                  <td className="left">{item.title}</td>
                  <td className="right">{item.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const title = Check
    ? quantityInfo.electricalConfiguration === "All Roof"
      ? `Project Overview (All Roof)`
      : `Project Overview (Roof ${index + 1})`
    : `Project Overview`;

  return (
    <div id="project-overview" className="project-overview">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="po-body">
        <p> {title} </p>
        {/* Project Info */}
        <div className="info">
          <p>Project Details</p>
          <table className="table">
            <tbody>
              {projectInfo.map((item, index) => {
                return (
                  <tr key={index} className="project-info-table-row">
                    <td className="left">{item.title}</td>
                    <td className="right">{item.value}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* Customer Info */}
        <div className="info">
          <p>Customer Details</p>
          <table className="table">
            <tbody>
              {customerInfo.map((item, index) => {
                return (
                  <tr key={index} className="project-info-table-row">
                    <td className="left">{item.title}</td>
                    <td className="right">{item.value}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="info">
          <p>Estimated Project Cost</p>
          <table className="table">
            <tbody>
              {ProjectDetail.map((item, index) => {
                return (
                  <tr key={index} className="project-info-table-row">
                    <td className="left">{item.title}</td>
                    <td className="right">{item.value}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender("PV Panel", pvPanel)}
          {/* PV Panel */}
          {tableRender("Solar Structure", solarStructure)}
          {/* PV Panel */}
          {tableRender("Inverter", inverter)}
          {/* PV Panel */}
          {tableRender("Environmental Benefits", environmentalBenifits)}

          {/* {tableRender("Estimated Project Cost", ProjectDetail)} */}
        </div>
      </main>

      {/* Footer */}

      <Footer pageNo={`3/${tableContent[tableContent.length - 1].pageNo}`} />
    </div>
  );
};

export default ProjectOverview;
